import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    root: {
        flexGrow: 1     
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    footer: {
        position: 'fixed',
        bottom: 0,
        left: 20,
        right: 0,
        textAlign: 'center'
    },
    footerText: {
        fontSize:'8pt'
    },
    linkText: {
        fontSize:'8pt',
        fontWeight: 'bold',
        textDecoration: 'underline'
    }
}));